/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import Layout from '../Layout/Layout';
import { SocketProvider } from '../SocketContext/SocketContext';
import UserLanguageSync from '../UserLanguageSync/UserLanguageSync';

const ProtectedRoute = ({ component: Component, useLayout = true, ...rest }) => {
    const location = useLocation();
    const token = localStorage.getItem('token');
    if (!token) {
        return (
            <Navigate
                to="/login"
                state={{ from: location }}
                replace
            />
        );
    }

    return (
        <SocketProvider>
            <UserLanguageSync />
            {useLayout ? (
                <Layout>
                    <Component {...rest} />
                </Layout>
            ) : (
                <Component {...rest} />
            )}
        </SocketProvider>
    );
};

ProtectedRoute.propTypes = {
    component: PropTypes.func.isRequired,
};

export default ProtectedRoute;
